<template>
<div class="chapter">
<div class="inner_page">
<div class="plm_hd">Contents</div>
<div class="sgc-toc-level-1">
<a href="#/Text/REV_genpref">General preface</a>
</div>
<div class="sgc-toc-level-1">
<a href="#/Text/REV_autpref">Author’s preface</a>
</div>
<div class="sgc-toc-level-1">
<a href="#/Text/REV_abbrev">Chief abbreviations</a>
</div>
<div class="sgc-toc-level-1">
<a href="#/Text/REV_structure">The structure of the drama</a>
</div>
<div class="sgc-toc-level-1s">
<a href="#/Text/REV_intro">Introduction</a>
</div>
<div class="sgc-toc-level-1s">
<a href="#/Text/REV_ch01#sigil_toc_id_1">The prologue (1:1–8)</a>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/REV_ch02#sigil_toc_id_2" title="Link target outside of Sample">Scene 1: The church in the world: <span class="italic2">seven letters dictated</span> (1:9 – 3:22)</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/REV_ch03#sigil_toc_id_3" title="Link target outside of Sample">Scene 2: Suffering for the church: <span class="italic2">seven seals opened</span> (4:1 – 8:1)</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/REV_ch04#sigil_toc_id_4" title="Link target outside of Sample">Scene 3: Warning for the world: <span class="italic2">seven trumpets sounded</span> (8:2 – 11:18)</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/REV_ch05#sigil_toc_id_5" title="Link target outside of Sample">Scene 4: The drama of history: <span class="italic2">seven visions of cosmic conflict</span> (11:19 – 15:4)</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/REV_ch06#sigil_toc_id_6" title="Link target outside of Sample">Scene 5: Punishment for the world: <span class="italic2">seven bowls poured out</span> (15:5 – 16:21)</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/REV_ch07#sigil_toc_id_7" title="Link target outside of Sample">Scene 6: Babylon the whore: <span class="italic2">seven words of justice</span> (17:1 – 19:10)</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/REV_ch08#sigil_toc_id_8" title="Link target outside of Sample">Scene 7: The drama behind history: <span class="italic2">seven visions of ultimate reality</span> (19:11 – 21:8)</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/REV_ch09#sigil_toc_id_9" title="Link target outside of Sample">Scene 8: Jerusalem the bride: <span class="italic2">seven final revelations</span> (21:9 – 22:19)</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/REV_ch10#sigil_toc_id_10" title="Link target outside of Sample">The epilogue (22:20–21)</span>
</div>
<div class="sgc-toc-level-1s">
<span href="#/Text/REV_sg" title="Link target outside of Sample">Study guide</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/REV_notes" title="Link target outside of Sample">Notes</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/REV_OT" title="Link target outside of Sample">The Bible Speaks Today: Old Testament series</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/REV_NT" title="Link target outside of Sample">The Bible Speaks Today: New Testament series</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/REV_themes" title="Link target outside of Sample">The Bible Speaks Today: Bible Themes series</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/REV_ata" title="Link target outside of Sample">About the Author</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/REV_moreIVP" title="Link target outside of Sample">More Titles from InterVarsity Press</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/REV_IVPtbs" title="Link target outside of Sample">IVP Academic Textbook Selector</span>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// REV_contents.vue?39e7fa8e